type LogoVariant = 'default' | 'variant2' | 'i'

type LogoSymbol = 'default' | 'brand01'

const VARIANT_COLORS: Record<LogoVariant, { mark: string; accent: string; word: string }> = {
  default: { mark: '#7437d8', accent: '#ffd447', word: '#000000' },
  variant2: { mark: '#7437d8', accent: '#7437d8', word: '#7437d8' },
  i: { mark: '#272238', accent: '#272238', word: '#272238' },
}

export function HaebomLogo({
  variant = 'default',
  symbol = 'default',
  height = 24,
}: {
  variant?: LogoVariant
  symbol?: LogoSymbol
  height?: number
}) {
  const c = VARIANT_COLORS[variant]

  return (
    <span
      style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}
      role="img"
      aria-label="해봄"
    >
      {symbol === 'brand01' ? (
        <Brand01Symbol height={height} />
      ) : (
        <svg
          width={height}
          height={height}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M4.05005 11.55C4.05005 7.20001 7.65005 3.75001 12.1501 3.75001C15.9001 3.75001 19.0501 6.30001 19.8001 9.75001"
            stroke={c.mark}
            strokeWidth="2.1"
            strokeLinecap="round"
          />
          <path
            d="M4.05005 11.55C4.05005 15.3 6.75005 18.45 10.5001 19.2L9.00005 21.75L13.6501 19.65"
            stroke={c.mark}
            strokeWidth="2.1"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.55001 12.75C9.12991 12.75 9.60001 12.2799 9.60001 11.7C9.60001 11.1201 9.12991 10.65 8.55001 10.65C7.97011 10.65 7.50001 11.1201 7.50001 11.7C7.50001 12.2799 7.97011 12.75 8.55001 12.75Z"
            fill={c.mark}
          />
          <path
            d="M11.7 12.75C12.2799 12.75 12.75 12.2799 12.75 11.7C12.75 11.1201 12.2799 10.65 11.7 10.65C11.1201 10.65 10.65 11.1201 10.65 11.7C10.65 12.2799 11.1201 12.75 11.7 12.75Z"
            fill={c.mark}
          />
          <path
            d="M14.85 12.75C15.4299 12.75 15.9 12.2799 15.9 11.7C15.9 11.1201 15.4299 10.65 14.85 10.65C14.2701 10.65 13.8 11.1201 13.8 11.7C13.8 12.2799 14.2701 12.75 14.85 12.75Z"
            fill={c.mark}
          />
          <path
            d="M17.8497 9.89993C20.2497 9.89993 22.1993 11.8505 22.1993 14.2505C22.1991 17.6905 17.8747 21.8758 17.8497 21.8999C17.8161 21.8675 13.5003 17.687 13.5001 14.2505C13.5001 11.8505 15.4497 9.89997 17.8497 9.89993ZM17.8497 12.6001C16.9387 12.6003 16.2005 13.3386 16.2003 14.2495C16.2003 15.1607 16.9386 15.8997 17.8497 15.8999C18.761 15.8999 19.5001 15.1608 19.5001 14.2495C19.4998 13.3385 18.7608 12.6001 17.8497 12.6001Z"
            fill={c.accent}
          />
        </svg>
      )}

      <svg
        height={(height * 18.0664) / 24}
        viewBox="0 0 33.6891 18.0664"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M33.6891 8.4375V10.9375H17.2047V8.4375H23.8258V7.40234H19.2555V0.429688H22.3219V1.73828H28.4938V0.429688H31.5992V7.40234H26.9899V8.4375H33.6891ZM22.3219 4.98047H28.4938V4.0625H22.3219V4.98047ZM31.736 11.7578V17.9102H19.0602V11.7578H31.736ZM22.1266 14.1602V15.4102H28.6696V14.1602H22.1266Z"
          fill={c.word}
        />
        <path
          d="M8.53516 2.53906V5H0V2.53906H2.77344V0.488281H5.83984V2.53906H8.53516ZM4.31641 5.54688C6.66016 5.56641 8.32031 7.38281 8.32031 9.94141C8.32031 12.5391 6.66016 14.375 4.31641 14.375C1.99219 14.375 0.273438 12.5391 0.273438 9.94141C0.273438 7.38281 1.99219 5.56641 4.31641 5.54688ZM4.31641 8.14453C3.53516 8.125 3.02734 8.73047 3.02734 9.94141C3.02734 11.1719 3.53516 11.7383 4.31641 11.7383C5.07812 11.7383 5.58594 11.1719 5.58594 9.94141C5.58594 8.73047 5.07812 8.125 4.31641 8.14453ZM15.7812 0V18.0664H12.8125V9.66797H11.9531V17.3633H9.02344V0.3125H11.9531V7.20703H12.8125V0H15.7812Z"
          fill={c.word}
        />
      </svg>
    </span>
  )
}

function Brand01Symbol({ height }: { height: number }) {
  return (
    <svg
      width={height}
      height={height}
      viewBox="0 0 160 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M27 77c0-29 24-52 54-52 25 0 46 17 51 40"
        fill="none"
        stroke="#7437D8"
        strokeWidth="14"
        strokeLinecap="round"
      />
      <path
        d="M27 77c0 25 18 46 43 51l-10 17 31-14"
        fill="none"
        stroke="#7437D8"
        strokeWidth="14"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="57" cy="78" r="7" fill="#7437D8" />
      <circle cx="78" cy="78" r="7" fill="#7437D8" />
      <circle cx="99" cy="78" r="7" fill="#7437D8" />
      <path
        d="M119 66c-16 0-29 13-29 29 0 23 29 51 29 51s29-28 29-51c0-16-13-29-29-29z"
        fill="#FFD447"
      />
      <circle cx="119" cy="95" r="11" fill="#fff" />
    </svg>
  )
}
